module.exports = __webpack_public_path__ + "img/accessory2.9608a5d2.svg";